import './jquery.visible.min';
var maxHeight = 0;
var winHeight = 0;
var winWidth = 0;
var mainTop = 0;
var headertop = null;
var header = null;
var headerLogo = null;
var navi = null;
var navTop_bevor = null;
var navHeightOrg = null;
var teaVideo = null;

$(document).ready(function() {
    if($('body').hasClass('startpage') && $(window).outerWidth() > 992) {
        makeMenue();
        $(window).on('resize', function() {
            makeMenue();
            $(window).trigger('scroll');
        });
    }
    header = document.getElementById('header');
    navHeightOrg = parseInt($('#navbar').outerHeight());
    headertop = document.getElementById('headertop');
    headerLogo = document.getElementById('headerlogo');
    navi = $('#navigation');
    winHeight = $(window).height();
    winWidth = $(window).width();
    mainTop = parseInt($('#main').css('padding-top'));
    window.addEventListener('orientationchange', function() {
        winHeight = $(window).height();
        winWidth = $(window).width();
    });

    $(window).on('resize', function() {
       winHeight = $(window).height();
       winWidth = $(window).width();
    });
    setTimeout(function() {
        initContent();
    }, 100);
});

function makeMenue() {
    teaVideo = $('#teaVideo');
    if(teaVideo.length) {
        var vidHeight = teaVideo.outerHeight();
        var newTop = 0;
        if(vidHeight > $(window).outerHeight()) {
            newTop = $(window).outerHeight() - 65;
        } else {
            newTop = vidHeight - 65;
            $('main>.grid-container').first().css('padding-top', $('#navigation').outerHeight());
        }

        $('#navigation').css('top', newTop);
        $('#navigation').css('opacity', 1);
    }
}

function initContent() {
    var iconname = '';
    var pfad = '';
    navTop_bevor = parseInt(navi.css('top'));
    maxHeight = document.body.clientHeight;
    $('img[usemap]').rwdImageMaps();
    $('.fontawsome-icon').each(function() {
        iconname = $(this).data('iconname');
        pfad = $(this).children().attr('src');
        $(this).load(pfad);
    });
    $('#teaVideo .active h1').css('left', '0px');
    $('#teaVideo .active p').css('left', '0px');
    parallax();
    parallaxGallery();
    if($(window).outerWidth() > 992)
        aniMenue();
    initTeaserSlider(true);
    $(window).on('scroll', function() {
        parallax();
        if(winWidth > 576) {
            if($(window).outerWidth() > 992)
                aniMenue();

            if((window.innerHeight + window.scrollY) >= document.body.offsetHeight - 300) {
                var neupos = ((document.body.offsetHeight - window.innerHeight - window.scrollY) * -1);
                $('.lawn').css('bottom', neupos);
            } else {
                $('.lawn').css('bottom', '-550px');
            }
        }
    });
    $(window).trigger('scroll');

    var tvideo = $('#teaservideo');
    if($(window).outerWidth() < 768 && tvideo.data('srcmobile') != '') {
        tvideo.attr('src', tvideo.data('srcmobile'));
    } else {
        tvideo.attr('src', tvideo.data('src'));
    }
    if(tvideo[0] !== undefined)
        tvideo[0].load();

    initFAQs();
}

function initFAQs() {
    $('.faqs-faq').each(function(index) {
        $(this).off('click').on('click', function() {
            if($(this).hasClass('show')) {
                $(this).removeClass('show');
            } else {
                $(this).addClass('show');
            }
        })
    });
}


function aniMenue() {
   var winTop = parseInt(window.scrollY);
   var woodNaviTop_Height = parseInt($('#wood_navi-top').outerHeight());

   var navTopNeu = navTop_bevor - winTop;

    var tmp1 = (navTop_bevor - winTop - 150) * -1 / 150;
    if(tmp1 > 1)
        tmp1 = 1;
    if(tmp1 < 0)
        tmp1 = 0;
    $('.nav-top-icons').css('opacity', 1 - tmp1);
    $('.nav-bottom-icons').css('opacity', tmp1);
    $('.nav-bottom-icons').css('pointer-events', 'auto');

   if(navTopNeu < (0 - woodNaviTop_Height)) {
       navTopNeu = 0 - woodNaviTop_Height;
       logoPosAni(parseInt($('#navbar').outerHeight()) + (parseInt($('#wood_navi-bottom').outerHeight()) / 4 * 3));
   } else {
       logoPosAni(0);
   }

   if(navTopNeu > navTop_bevor) {
       navTopNeu = navTop_bevor;
   }

    if($('body').hasClass('default-page') === false) {
        navi.css('top', navTopNeu + 'px');
    }
   navHeightAni(winTop);
}
function logoPosAni(posTop) {
    if($('body').hasClass('default-page')) {
        var newpos = (parseInt($('#navbar').outerHeight()) + (parseInt($('#wood_navi-bottom').outerHeight()) / 4 * 3));
        if(newpos > 117)
            newpos = 117;

        if(winWidth < 992) {
            newpos = 65;
        } else {

        }

        $('#logo').css('top', newpos + 'px');
    } else {
        $('#logo').css('top', posTop + 'px');
    }
}

function navHeightAni(scrollTop) {
    // var navbarHeight = parseInt($('#navbar').outerHeight());

    var tmp = navHeightOrg - (scrollTop / 16);
    if($('body').hasClass('default-page')) {
        tmp = 50;
    } else {
        if (tmp < 50)
            tmp = 50;
        if (navHeightOrg < tmp)
            tmp = navHeightOrg;
    }

    $('#navbar').css('height', tmp);
    $('.dropdown-menu').css('top', tmp);
}

var activePos = 0;
function parallaxGallery() {
    var elementCount = $('.gallery-inner picture').length;
    var i = 1;

    if(activePos !== 0) {
        if(activePos === elementCount) {
            activePos = 1;
        } else {
            activePos++;
        }
        $('.gallery-inner').children('picture').each(function () {
            console.log(i);
            if(activePos === i) {
                $(this).addClass('active');
            } else {
                $(this).removeClass('active');
            }

            i++;
        });
    } else {
        $('.gallery-inner picture:first').addClass('active');
        activePos = 1;
    }

    setTimeout(function() {
        parallaxGallery();
    }, 5000);
}

function parallax() {
    var objekte = document.getElementsByClassName('parallax-video');

    var i = 0;
    var beforeOverlayed = false;
    var elemente = [];

    Array.prototype.forEach.call(objekte, function (el) {
        var pic = el.firstElementChild;
        var winTop = el.getBoundingClientRect().top;
        var moveTop = 0;
        if(0 > (winTop - winHeight)) {
            moveTop = (winTop) / 2 * -1;
        }

        // pic.style.bottom = '0px';

        var picdata = getComputedStyle(pic);
        var picturedata = getComputedStyle(pic);

        var tmp1 = parseInt(parseInt(picdata.height) - moveTop);
        var tmp2 = parseInt(picturedata.height);
        pic.dataset.tmp1 = tmp1;
        pic.dataset.tmp2 = tmp2;
        if(tmp1 < tmp2)
            pic.style.transform = 'translate3d(0px, ' + moveTop + 'px, 0px)';

        i++;
    });

    $('.parallax').each(function() {
        var $elem = $(this);

        // if($elem.isVisible()) {
            var parent_top = $elem.offset().top;
            var window_bottom = $(window).scrollTop();
            var oVal = ((window_bottom - parent_top + 400) / 3);

            if ($elem.parent().hasClass('teaser--halb')) {
                // oVal = ((window_bottom - parent_top) / 3);
            }

            var tmp = parseInt($elem.height()) * -1;
            if(tmp > oVal)
                oVal = tmp;

            $elem.children().css('transform', 'translate3d(0px, ' + oVal + 'px, 0px)');
        // }
    });
}

function initTeaserSlider(start = false) {
    if(start !== true) {
        $('#teaserBilder').each(function (index) {
            var tmp = $(this);
            var activeIndex = 0;
            var fertig = false;
            if ($('#teaVideo').visible(true)) {
                tmp.children('.teaser--bg').each(function (index2) {
                    var aktuell = $(this);
                    if (aktuell.hasClass('active') === true && fertig === false) {
                        if (aktuell.next().length) {
                            aktuell.removeClass('active');
                            aktuell.next().addClass('active');
                            fertig = true;
                        } else {
                            aktuell.removeClass('active');
                            aktuell.parent().children(':first').addClass('active');
                            fertig = true;
                        }
                    }
                })
            }
        });
    }
    setTimeout(function() {
        initTeaserSlider();
    }, 5000);
}

/*
* rwdImageMaps jQuery plugin v1.6
*
* Allows image maps to be used in a responsive design by recalculating the area coordinates to match the actual image size on load and window.resize
*
* Copyright (c) 2016 Matt Stow
* https://github.com/stowball/jQuery-rwdImageMaps
* http://mattstow.com
* Licensed under the MIT license
*/
;(function(a){a.fn.rwdImageMaps=function(){var c=this;var b=function(){c.each(function(){if(typeof(a(this).attr("usemap"))=="undefined"){return}var e=this,d=a(e);a("<img />").on('load',function(){var g="width",m="height",n=d.attr(g),j=d.attr(m);if(!n||!j){var o=new Image();o.src=d.attr("src");if(!n){n=o.width}if(!j){j=o.height}}var f=d.width()/100,k=d.height()/100,i=d.attr("usemap").replace("#",""),l="coords";a('map[name="'+i+'"]').find("area").each(function(){var r=a(this);if(!r.data(l)){r.data(l,r.attr(l))}var q=r.data(l).split(","),p=new Array(q.length);for(var h=0;h<p.length;++h){if(h%2===0){p[h]=parseInt(((q[h]/n)*100)*f)}else{p[h]=parseInt(((q[h]/j)*100)*k)}}r.attr(l,p.toString())})}).attr("src",d.attr("src"))})};a(window).resize(b).trigger("resize");return this}})(jQuery);